import { apiSlice } from "../../../app/services/authServices";

export const divisionSlice = apiSlice.injectEndpoints({
    tagTypes: ["Division"],
    endpoints: builder => ({
        getAllDivisions: builder.query({
            query: () => ({
                url: 'Division/GetAllDivisions',
                method: 'GET',
            }),
            providesTags: ['Division'],
        }),
        getDivisionDriverNumber: builder.query({
            query: () => ({
                url: 'Division/GetDriverNumber',
                method: 'GET',
            }),
            providesTags: ['Division'],
        }),
        createDivision: builder.mutation({
            query: (body) => ({
                url: 'Division/CreateDivision',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Division'],
        }),
        deleteDivision: builder.mutation({
            query: (DivisionId) => ({
                url: `Division/DeleteDivision?DivisionId=${DivisionId}`,
                method: 'POST'
            }),
            invalidatesTags: ['Division'],
        }),
        getDivisionById: builder.query({
            query: (DivisionId) => ({
                url: `Division/GetDivisionById?DivisionId=${DivisionId}`,
                method: 'GET',
            }),
            providesTags: ['DivisionById'],
        }),
        updateDivision: builder.mutation({
            query: (body) => ({
                url: 'Division/UpdateDivision',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['DivisionById'],
        }),

    }),
});

export const { useGetDivisionDriverNumberQuery, useLazyGetDivisionByIdQuery, useGetDivisionByIdQuery, useUpdateDivisionMutation, useDeleteDivisionMutation, useGetAllDivisionsQuery, useCreateDivisionMutation } = divisionSlice;